import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

const isOauthPartnerPolicy = objectOf({
  integration_partner: string,
  all_app_groups: boolean,
  app_group_ids: arrayOf(string),
  last_updated_by_id: anyOf(nullOrUndefined, string),
  last_updated_by_name: anyOf(nullOrUndefined, string),
  last_updated_at: anyOf(nullOrUndefined, string),
});

export const isGetCompaniesCompanyIdOauthMcpSettingsPartnerPoliciesResult = objectOf({
  partner_apps_enabled: boolean,
  partner_policies: arrayOf(isOauthPartnerPolicy),
});
